import React, { useState } from 'react';
import { PromotedSportSingleType } from 'src/domains/layouts/webview/components/promotedSports/PromotedEventsState.state';
import { observer } from 'src/utils/mobx-react';
import { makeObservable, observable } from 'mobx';
import { CompetitionData } from './CompetitionData';
import { Collapse } from 'src/ui/components/collapse/sports/02/Collapse';
import { Collapse as CollapseUnified } from 'src/ui/components/collapse/sports/05/Collapse';
import { PromotedSportSectionContainer } from './PromotedSportSection.style';
import { useCommon } from 'src/domains/common/Common';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';
import { TranslationsStore } from 'src/domains/layouts/state/translationsStore/TranslationsStore';

interface PromotedSportWrapperPropsType {
    sportSlug: string;
    sportData: PromotedSportSingleType;
}

class State {
    @observable public isOpenedSport: boolean = true;

    public constructor() {
        makeObservable(this);
    }

    public setIsOpened = (): void => {
        this.isOpenedSport = !this.isOpenedSport;
    };
}

export const PromotedSportSectionWrapper = observer(
    'PromotedSportSectionWrapper',
    ({ sportSlug, sportData }: PromotedSportWrapperPropsType) => {
        const common = useCommon();

        const [state] = useState(() => new State());

        const {
            unifiedSportEventsTable,
            componentVariants: { sportsbookVariant },
        } = ConfigComponents.get(common).unifiedComponentConfig;
        const translationsStore = TranslationsStore.get(common);
        const sportName = common.models.getSport(sportSlug)?.name ?? translationsStore.translateSport(sportSlug);
        const competitionsSorted = sportData.competitions_list.sort((a, b) => a.display_order - b.display_order);

        return (
            <PromotedSportSectionContainer variant={sportsbookVariant}>
                {unifiedSportEventsTable ? (
                    <CollapseUnified
                        isOpen={state.isOpenedSport}
                        data-test='promoted-event-group'
                        handleToggle={state.setIsOpened}
                        title={sportName}
                    />
                ) : (
                    <Collapse
                        isOpen={state.isOpenedSport}
                        data-test='promoted-event-group'
                        handleToggle={state.setIsOpened}
                        title={sportName}
                        sportId={sportName}
                    />
                )}

                {state.isOpenedSport ? (
                    <>
                        {competitionsSorted.map((competition) => (
                            <CompetitionData
                                key={competition.id}
                                sportSlug={sportSlug}
                                competition={competition}
                            />
                        ))}
                    </>
                ) : null}
            </PromotedSportSectionContainer>
        );
    }
);
